<template>
    <div class="electricity">
        <Title firstName="安防监控" lastName="SECURITY AND PROTECTION MONITORING"/>
        <div class="echarts">
            <div class="selectMonitor" >
                <p @click="changeMonitor">
                    {{monitor}}
                    <i class="el-icon-arrow-down"></i>
                </p>
                
            </div>
            <div id="monitoring" >
                <iframe width="100%" height="100%" v-show="!showList"  :src="'https://www.energydt.cn/proxy/webrtc/index.html?' + iframesrc" frameborder="0"></iframe>
                <!-- 全屏按钮 -->
                <!-- 全屏按钮 -->
                <div id="fullscreen1"  >
                    
                    <img :src="!isFull?fullSrc[0]:fullSrc[1]" alt="全屏" />{{!isFull?'':'取消全屏'}}
                </div>
                <div class="kong" v-show="monitorList.length <= 0">
                    <img src="@/assets/img/加载视频.png" alt="" v-show="true" />
                    <p>无监控数据</p>
                </div>
            </div>

            <div class="list" v-show="showList">
                <SelectList :selectList="monitorList" @tabTitle="tabTitle" keyk="device_id" keyval="device_name"/>
            </div>
            <div class="bottom"></div>
        </div>
    </div>
</template>

<script>
import screenfull from "screenfull"; // 引入全屏显示
const Title = () => import('../../components/title/Title')
const SelectList = () => import('../../components/title/selectList.vue')

export default {
    props:['areaId'],
    data(){
        return {
            isFull:false,
            showList:false,
            monitor:'',
            iframesrc:'',
            monitorList:[],
            fullSrc:[require('@/assets/img/fullScreen.png'),require('@/assets/img/full_cancel.png')]

        }
    },
    components:{
        Title,SelectList
    },
    mounted(){
        this.fullscreen()
        setTimeout(()=>{
            this.getLoadMonitor()
        },300)
    },
    methods:{
        // 全屏显示 
        fullscreen(){
            const element = document.getElementById('monitoring');
            document.getElementById('fullscreen1').addEventListener('click', () => {
                this.isFull = !this.isFull
                if(this.isFull){
                    screenfull.request(element); // 元素全屏
                }else{
                    screenfull.toggle(); // 元素全屏
                }
            });
        },
        changeMonitor(){
            this.showList = !this.showList
        },
        tabTitle(monitor){
            this.showList = false
            this.monitor = monitor.device_name
            this.iframesrc = JSON.parse(monitor.device_details).roomName
        },
        getLoadMonitor(){
             let arr = this.$store.getters.getRooms(this.areaId).details[0]
             if(arr.length <= 0 ){
                 return 
             }
            this.monitor = arr[0].device_name
            this.monitorList = arr
            this.iframesrc = JSON.parse(arr[0].device_details).roomName
            
        }
    }
}
</script>

<style lang="less" scoped>
    .electricity{
        height: 33.3vh;
        width: 20vw;
        position: fixed;
        top: 68.1vh;
        right: 1vw;

        .echarts{
            position: relative;
            height: 25vh;
            padding-bottom: 1vh;
            background:  linear-gradient(0deg, rgba(0, 33, 59, 0.6) 0%, rgba(3, 13, 24, 0.7) 100%);

            .selectMonitor{
                height: 3vh;
                p{
                    position: absolute;
                    right: 1vh;
                    top: 0.7vh;
                    font-size: 14rem;
                    color: #E6F3FD ;
                    cursor: pointer;
                }
            }

            #monitoring{
                height: 21vh;
                position: relative;
                text-align: center;
                background: #000;
                &>.kong{
                    width: 100rem;
                    font-size: 14rem;
                    text-align: center;
                    color: #fff;
                    position: absolute;
                    left:calc(50% - 50rem);
                    top: calc(50% - 50rem);
                    img{
                        width: 80rem;
                        height: 96rem;
                        margin-bottom: 5rem;
                    }
                }
                #fullscreen1{
                    position: absolute;
                    right:0.5vw ;
                    bottom: 1vh;
                    cursor: pointer;
                    color: #E6F3FD;
                    font-size: 20rem;
                    img{
                        width: 2.5vh;
                        height: 2.5vh;
                        vertical-align: middle;
                        margin-right: 5rem;
                    }
                }
            }
            
            .list{
                height: 10.5vh;
                width: 100%;
                position: absolute;
                left: 0;
                top: 3vh;
                z-index: 11;
            }

            .bottom{
                width: 20vw;
                height: 1vh;
                background: url(../../assets/img/板块装饰线.png) no-repeat;
                block-size: 100% 100%;
                position: absolute;
                bottom: 0;
                left: 0;
            }
        }

        
    }

</style>